import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as SlideTextActions from '../actions/slide-text.actions';
import { ExaminationSlideText, ExaminationSlideTextList } from '../../model/examinationSlides.model';
import { ExaminationService } from '../../service/examination.service';
import { ExaminationSlidesTextService } from '../../service/examination-slide-text.service';

@Injectable()
export class SlideTextEffects {

    constructor(
        private actions: Actions,
        private _examinationService: ExaminationService,
        private examinationSlidesTextService: ExaminationSlidesTextService,
    ) { }

    getSlideText = createEffect(() => this.actions.pipe(
        ofType(SlideTextActions.GetSlideText),
        exhaustMap(action => {
            return this.examinationSlidesTextService.getExaminationsSlidesText(action.params).pipe(
                map((slideTexts: ExaminationSlideTextList) => {
                    return SlideTextActions.GetSlideTextSuccess({ payload: slideTexts });
                }),
                catchError(() => of(SlideTextActions.GetSlideTextFailure()))
            )
        })
    ));

    getDocumentFromUrl = createEffect(() => this.actions.pipe(
        ofType(SlideTextActions.GetSlideTextfromurl),
        exhaustMap(action => {
            return this.examinationSlidesTextService.getExaminationsSlideTextsByUrl(action.url).pipe(
                map((slideTexts: ExaminationSlideTextList) => {
                    return SlideTextActions.GetSlideTextSuccess({ payload: slideTexts });
                }),
                catchError(() => of(SlideTextActions.GetSlideTextFailure()))
            )
        })
    ));
}

